import styled, { css } from 'styled-components';
import PreviewWrapper from 'gatsby-theme-vehicles/src/components/preview/components/wrapper';

export default styled(PreviewWrapper)`
  background-color: ${({ theme }) => theme.backgroundColor};

  ${({ $rowLayout }) => !$rowLayout && css`
    border: 1px solid ${({ theme }) => theme.grayLightColor};
    border-radius: ${({ theme }) => theme.borderRadius};

    > *:first-child {
      border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
    }
    > *:last-child {
      border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
    }
  `}
  ${({ $rowLayout }) => $rowLayout && css`
    grid-template-columns: ${({ columns = '16.5rem 2fr' }) => columns};
  `}
`;
